import injectSheet from 'react-jss'
import SearchResultFlightInformation from './SearchResultFlightInformation'
import styles from './SearchResultFlightInformation.styles'

export default injectSheet(styles)(SearchResultFlightInformation)
